module.exports = __webpack_public_path__ + "img/ray-gun.55acbfce.svg";